/**
 * @generated SignedSource<<ba6468149a0526c7e0c9d8aa5bcd4bad>>
 * @relayHash dae3818a3d3b27044a34a238b3abce7e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dae3818a3d3b27044a34a238b3abce7e

import { ConcreteRequest } from 'relay-runtime';
export type PatientRecordExportStatus = "COMPLETED" | "DELIVERING" | "DISCARDED" | "FAILED" | "GENERATING_SUMMARY" | "PACKAGING" | "SUMMARY_READY";
export type usePatientRecordExportRequestUpdatedSubscription$variables = {
  requestId: string;
};
export type usePatientRecordExportRequestUpdatedSubscription$data = {
  readonly ch_patientRecordExportRequestUpdated: {
    readonly appointmentsFetched: boolean;
    readonly id: string;
    readonly status: PatientRecordExportStatus;
    readonly summaryFileId: string | null;
    readonly updatedAt: string;
  };
};
export type usePatientRecordExportRequestUpdatedSubscription = {
  response: usePatientRecordExportRequestUpdatedSubscription$data;
  variables: usePatientRecordExportRequestUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "requestId",
        "variableName": "requestId"
      }
    ],
    "concreteType": "PatientRecordExportRequestChange",
    "kind": "LinkedField",
    "name": "ch_patientRecordExportRequestUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summaryFileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appointmentsFetched",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatientRecordExportRequestUpdatedSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePatientRecordExportRequestUpdatedSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "dae3818a3d3b27044a34a238b3abce7e",
    "metadata": {},
    "name": "usePatientRecordExportRequestUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "3b64c1d699e2d794c0c1fcc87f859449";

export default node;
